<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import { getContext } from "svelte";

  const { data, xGet, yGet, xScale, yScale, padding } = getContext("LayerCake");

  let {
    axis = "x",
    formatTick = (d) => d,
  } = $props();

  let bandwidth = $derived(
    axis === "x" ? $xScale.bandwidth?.() ?? 0 : $yScale.bandwidth?.() ?? 0
  );
</script>

{#if axis === "x"}
  <div class="html-labels html-labels-x">
    {#each $data as d}
      {@const x = $xGet(d)}
      <div
        class="label label-x"
        style="left: {x}px; top: {$yScale.range()[0]}px; width: {bandwidth}px;"
      >
        {formatTick(d.name ?? d)}
      </div>
    {/each}
  </div>
{:else}
  <div class="html-labels html-labels-y">
    {#each $data as d}
      {@const y = $yGet(d)}
      <div
        class="label label-y"
        style="top: {y}px; left: {-$padding.left}px; width: {$padding.left - 6}px; height: {bandwidth}px;"
      >
        {formatTick(d.name ?? d)}
      </div>
    {/each}
  </div>
{/if}

<style>
  .html-labels {
    position: relative;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .label {
    position: absolute;
    font-size: 14px;
    line-height: 1.2;
    color: #000;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }

  .label-x {
    text-align: center;
    padding-top: 6px;
  }

  .label-y {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 6px;
  }
</style>
